import React from "react";
import {Navigate, useParams} from 'react-router-dom';
// import axios from 'axios';
import Menu from "../components/menu/Menu";
import Reco from "../components/reco/Reco";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
import "../generales.css";
// import { trackPromise } from 'react-promise-tracker';

const RecoMain = () => {

    const params = useParams();
    var idcol = null;
    
    if(params){
        idcol = params.idcol
    }

    if(!sessionStorage.getItem('userData')){
        return <Navigate to="/"  />;
    }
    else{
        Verify()
    }
    
    return(
        <>
            <Menu />
            <Container fluid className="container_webcam">
                <Reco id={idcol} />
            </Container>
        </>
    )
};

export default RecoMain;
